export default "__VITE_ASSET__DgBUwZnZ__"